// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wxAZarTgAM4rLTRffyp5{flex-direction:column;gap:8px;display:flex}.Ff7paPiYBkI9n1Yn79xT [aria-label=MessageField]:not(:focus-within){border-color:var(--red-80)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `wxAZarTgAM4rLTRffyp5`,
	"fieldError": `Ff7paPiYBkI9n1Yn79xT`
};
export default ___CSS_LOADER_EXPORT___;
